import { useEffect } from 'react';

export const usePerformanceMonitor = (enabled = false) => {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    console.log('🔍 Bundle Debug Monitor Started');
    console.log('================================');

    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.name.includes('.js')) {
          const resourceEntry = entry as PerformanceResourceTiming;
          console.log(`📦 JS Bundle: ${entry.name.split('/').pop()}`, {
            duration: Math.round(entry.duration) + 'ms',
            size: resourceEntry.transferSize ? `${Math.round(resourceEntry.transferSize / 1024)}KB` : 'N/A',
            type: entry.entryType
          });
        }
        if (entry.entryType === 'paint') {
          console.log(`🎨 Paint: ${entry.name}`, {
            time: Math.round(entry.startTime) + 'ms'
          });
        }
      }
    });

    observer.observe({ entryTypes: ['navigation', 'resource', 'paint'] });

    // Log chunk loading
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const url = args[0] as string;
      if (url.includes('.js')) {
        console.log(`🔄 Loading chunk: ${url.split('/').pop()}`);
        const start = performance.now();
        const response = await originalFetch(...args);
        const end = performance.now();
        console.log(`✅ Chunk loaded: ${url.split('/').pop()} in ${Math.round(end - start)}ms`);
        return response;
      }
      return originalFetch(...args);
    };

    // Bundle analysis on load
    window.addEventListener('load', () => {
      setTimeout(() => {
        const jsResources = performance.getEntriesByType('resource')
          .filter(r => r.name.includes('.js'))
          .map(r => {
            const resourceEntry = r as PerformanceResourceTiming;
            return {
              name: r.name.split('/').pop(),
              size: Math.round((resourceEntry.transferSize || 0) / 1024),
              duration: Math.round(r.duration)
            };
          });

        console.log('📊 Bundle Loading Summary:');
        console.table(jsResources);
        console.log(`📦 Total JS: ${jsResources.reduce((sum, r) => sum + r.size, 0)}KB`);
        console.log('🚀 Bundle chunks loaded:', jsResources.length);
        
        // Show performance metrics
        const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        console.log('⚡ Performance Metrics:');
        console.log(`  DOM Content Loaded: ${Math.round(navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart)}ms`);
        console.log(`  Full Page Load: ${Math.round(navigation.loadEventEnd - navigation.fetchStart)}ms`);
      }, 1000);
    });

    return () => {
      observer.disconnect();
      window.fetch = originalFetch;
    };
  }, [enabled]);
};